export var ConversationStatus;
(function (ConversationStatus) {
    ConversationStatus["OPEN"] = "open";
    ConversationStatus["AWAITING_APPROVAL"] = "awaiting_approval";
    ConversationStatus["AWAITING_INPUT"] = "awaiting_input";
    ConversationStatus["NEEDS_HUMAN"] = "needs_human";
    ConversationStatus["RESOLVED"] = "resolved";
    ConversationStatus["CLOSED"] = "closed";
})(ConversationStatus || (ConversationStatus = {}));
export var ConversationRunStatus;
(function (ConversationRunStatus) {
    ConversationRunStatus["PENDING"] = "pending";
    ConversationRunStatus["RUNNING"] = "running";
    ConversationRunStatus["AWAITING_APPROVAL"] = "awaiting_approval";
    ConversationRunStatus["AWAITING_INPUT"] = "awaiting_input";
    ConversationRunStatus["COMPLETED"] = "completed";
    ConversationRunStatus["FAILED"] = "failed";
})(ConversationRunStatus || (ConversationRunStatus = {}));
export var ConversationTaskApprovalStatus;
(function (ConversationTaskApprovalStatus) {
    ConversationTaskApprovalStatus["NOT_REQUIRED"] = "not_required";
    ConversationTaskApprovalStatus["PENDING"] = "pending";
    ConversationTaskApprovalStatus["APPROVED"] = "approved";
    ConversationTaskApprovalStatus["AUTO_APPROVED"] = "auto_approved";
    ConversationTaskApprovalStatus["REJECTED"] = "rejected";
})(ConversationTaskApprovalStatus || (ConversationTaskApprovalStatus = {}));
export var ConversationTaskExecutionStatus;
(function (ConversationTaskExecutionStatus) {
    ConversationTaskExecutionStatus["PENDING"] = "pending";
    ConversationTaskExecutionStatus["EXECUTED"] = "executed";
    ConversationTaskExecutionStatus["FAILED"] = "failed";
    ConversationTaskExecutionStatus["SKIPPED"] = "skipped";
})(ConversationTaskExecutionStatus || (ConversationTaskExecutionStatus = {}));
//# sourceMappingURL=conversation.js.map